// import analytics from '@utils/analytics';
import React, { Suspense, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Button from '@stone/ui/button/Button';
import LoginOrRegisterColumn from '@stone/components/login/LoginOrRegisterColumn';
import A11YMenuAccountBar from '@stone/components/a11y/A11YMenuAccountBar';
import useMediaQueries from '@stone/hooks/useMediaQueries';
const ModalDrawer = React.lazy(() => import('@stone/components/modal/ModalDrawer'));
const ModalDialog = React.lazy(() => import('@stone/components/modal/ModalDialog'));
const LoginModal = (props) => {
    const { t } = useTranslation();
    const { isMobile } = useMediaQueries();
    const [open, setOpen] = useState(false);
    const [openRegister, setOpenRegister] = useState(false);
    const [forceReload, setForceReload] = useState(false);
    const ModalComponent = props.drawer ? ModalDrawer : ModalDialog;
    const modalProps = (props.drawer && {
        a11yBar: React.createElement(A11YMenuAccountBar, null),
        hideContentLabel: true,
        contentLabel: t('modal.loginregister.title'),
    }) || {
        // colLg: 14,
        // colXxl: 12,
        // innerColClasses: 'col-lg-23',
        fullHeight: true,
        fullWidth: isMobile,
        image: window.globalstaticurl + '/login/' + (props.incontext ? 'bg-' + props.incontext + '.jpg' : 'bg-login.jpg'),
        contentLabel: t('modal.loginregister.title'),
        subtitle: t('modal.loginregister.subtitle'),
    };
    // [ UPDATE EXTERNAL => SYNC INTERNAL ]
    useEffect(() => {
        if ((props === null || props === void 0 ? void 0 : props.modalStatus) != undefined && (props === null || props === void 0 ? void 0 : props.modalStatus) != open) {
            setOpen(props === null || props === void 0 ? void 0 : props.modalStatus);
        }
    }, [props === null || props === void 0 ? void 0 : props.modalStatus]);
    // [ UPDATE INTERNAL => SYNC EXTERNAL ]
    useEffect(() => {
        if ((props === null || props === void 0 ? void 0 : props.updateStatus) != undefined && (props === null || props === void 0 ? void 0 : props.modalStatus) != open) {
            props.updateStatus(open);
        }
        if (!open && forceReload) {
            if (props === null || props === void 0 ? void 0 : props.linkreload) {
                window.location.href = props.linkreload;
            }
            else {
                window.location.reload();
            }
        }
    }, [open]);
    if (window.loggedin) {
        return React.createElement(React.Fragment, null);
    }
    const hideElements = !props.drawer ? ['mainHeading', 'emailHeading', 'wishlistbutton', 'registerHeading', 'benefits'] : [];
    const slots = (!props.drawer && {
        sociallogintext: React.createElement(React.Fragment, null, t('register.fasterwithsocial')),
        emailbottomtext: (React.createElement("div", { className: "login-modal-bottom" },
            React.createElement("p", null, t('modal.loginregister.text')))),
        passwordheading: React.createElement(React.Fragment, null), //render nothing
    }) ||
        {};
    const LoginOrRegisterComponent = () => (React.createElement(LoginOrRegisterColumn, { defaultRegister: openRegister, setForceReload: setForceReload, closeModal: () => setOpen(false), onBack: () => setOpen(false), linkreload: props.linkreload, from: 'loginmodal', updateLoggeedStatus: props.updateLoggeedStatus, reloadPageRegisteredInStore: props.reloadPageRegisteredInStore, componentContext: props.drawer ? 'drawer' : 'modal', slots: slots, hideElements: hideElements, rememberme: props.rememberme, inAccountMenu: props.drawer }));
    return (React.createElement(React.Fragment, null,
        (props === null || props === void 0 ? void 0 : props.inWishlist) && (React.createElement("div", { className: "wishlist-login-box" },
            React.createElement("p", { dangerouslySetInnerHTML: { __html: t('wishlist.guestmessage') } }),
            React.createElement("div", { className: "wrapper-buttons" },
                React.createElement(Button, { cls: ['button--tertiary'], type: "button", ariaHaspopup: "dialog", onClick: () => {
                        setOpen(true);
                        // analytics.wishlistInteractionLoginRegister();
                    } }, t('login.toyouraccount'))))),
        React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
            React.createElement(ModalComponent, Object.assign({ contentLabel: t('modal.loginregister.title'), isOpen: open, className: classNames('login-modal', { 'in-drawer': props.drawer, 'in-dialog': !props.drawer }), onRequestClose: () => {
                    setOpen(false);
                    setOpenRegister(false);
                }, visuallyhidden: true }, modalProps), LoginOrRegisterComponent()))));
};
export default LoginModal;
